export class ReadyForPaymentEvent extends Event {
  static type = 'ready-for-payment' as const

  constructor() {
    super(ReadyForPaymentEvent.type, { bubbles: true, composed: true })
  }
}


export class StartPaymentEvent extends Event {
  static type = 'start-payment' as const

  constructor() {
    super(StartPaymentEvent.type, { bubbles: true, composed: true })
  }
}


export class SelectingPaymentMethodEvent extends Event {
  static type = 'selecting-payment-method' as const

  methodId: string

  constructor(methodId: string) {
    super(SelectingPaymentMethodEvent.type, { bubbles: true, composed: true })

    this.methodId = methodId
  }
}


export class StartPaymentFailedEvent extends Event {
  static type = 'start-payment-failed' as const

  public message: string

  constructor(message: string) {
    super(StartPaymentFailedEvent.type, { bubbles: true, composed: true })

    this.message = message
  }
}


export class StartPaymentPayloadCreationFailedEvent extends Event {
  static type = 'start-payment-payload-creation-failed' as const

  constructor() {
    super(StartPaymentPayloadCreationFailedEvent.type, { bubbles: true, composed: true })
  }
}


export class SelectingPartialPaymentEvent extends Event {
  static type = 'selecting-partial-payment' as const

  paymentType: string

  constructor(payment_type: string) {
    super(SelectingPartialPaymentEvent.type, { bubbles: true, composed: true })

    this.paymentType = payment_type
  }
}


declare global {
  interface GlobalEventHandlersEventMap {
    [ReadyForPaymentEvent.type]: ReadyForPaymentEvent,
    [StartPaymentEvent.type]: StartPaymentEvent,
    [SelectingPaymentMethodEvent.type]: SelectingPaymentMethodEvent,
    [StartPaymentFailedEvent.type]: StartPaymentFailedEvent,
    [StartPaymentPayloadCreationFailedEvent.type]: StartPaymentPayloadCreationFailedEvent,
    [SelectingPartialPaymentEvent.type]: SelectingPartialPaymentEvent,
  }
}
